import React from 'react';

const ReportesProgreso = () => {
  // Datos simulados para el reporte de progreso
  const reportes = [
    {
      nombre: 'Matemáticas - 4to Grado',
      progreso: 50,
      tareas: [
        { nombre: 'Tarea 1 - Operaciones Básicas', estado: 'Completada' },
        { nombre: 'Tarea 2 - Álgebra', estado: 'Pendiente' },
        { nombre: 'Tarea 3 - Fracciones', estado: 'Pendiente' },
      ],
    },
    {
      nombre: 'Ciencias - 4to Grado',
      progreso: 75,
      tareas: [
        { nombre: 'Tarea 1 - El Ciclo del Agua', estado: 'Completada' },
        { nombre: 'Tarea 2 - Estados de la Materia', estado: 'Completada' },
        { nombre: 'Tarea 3 - Ecosistemas', estado: 'Pendiente' },
      ],
    },
  ];

  return (
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">Reporte de Progreso</h1>

        {reportes.map((reporte, index) => (
          <div className="card mb-4" key={index}>
            <div className="card-header">
              <h5 className="card-title mb-0">Curso: {reporte.nombre}</h5>
            </div>
            <div className="card-body">
              <h6>Progreso General: {reporte.progreso}%</h6>
              <div className="progress mb-4">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${reporte.progreso}%` }}
                  aria-valuenow={reporte.progreso}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <h6>Tareas:</h6>
              <ul className="list-group mb-3">
                {reporte.tareas.map((tarea, tareaIndex) => (
                  <li className="list-group-item" key={tareaIndex}>
                    {tarea.nombre}{' '}
                    <span
                      className={`badge bg-${
                        tarea.estado === 'Completada' ? 'success' : 'warning'
                      } float-end`}
                    >
                      {tarea.estado}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
  );
};

export default ReportesProgreso;
